module.exports = "/_next/static/images/8ab3a8fdccccb05199ace16a76140234-man-with-cellphone-lg@3x.jpg.webp";